<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: calc(100% - 20px);margin: 0 20px;overflow-y: auto">
      <div style="height: 50px;">
<!--        <el-input-->
<!--          prefix-icon="el-icon-search"-->
<!--          placeholder="输入服务内容搜索"-->
<!--          v-model="searchKeyword"-->
<!--          clearable-->
<!--          style="width: 300px"-->
<!--        >-->
<!--        </el-input>&nbsp;-->
        <el-button type="primary" plain icon="el-icon-plus" @click="addServiceContent()">新增绑定服务内容</el-button>
      </div>
      <div style="max-height: calc(100% - 100px);overflow-y: auto">
        <el-table
          v-loading="loading"
          element-loading-text="加载中，请耐心等待。"
          :data="tableData"
          border
          style="width: 100%"
          highlight-current-row
          ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
          align="center">
          </el-table-column>
          <el-table-column
            prop="service_name"
            label="服务内容"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column
            label="服务商"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{getSupplierOrg(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务类型"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.st_id !== 0">{{getUpTypeName(scope.row.st_id)}}</span>
<!--              <span>{{getServiceType(scope.row)}}</span>-->
            </template>
          </el-table-column>
          <el-table-column
            prop="time_duration"
            label="服务时长(分钟)"
            min-width="90"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.time_duration !== ''">{{ scope.row.time_duration }} 分钟</span>
            </template>
          </el-table-column>
          <el-table-column
            label="服务价格"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.price !== ''">{{parseFloat(scope.row.price) / 100}}元</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updated_on"
            label="录入时间"
            min-width="90"
            align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="120"  class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editServiceContent(scope.row)"></i>
              <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delServiceContent(scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <!--created update-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow"
      width="550px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div>
          <span>{{openTitle}}</span>
        </div>
        <div class="line-title"></div>
      </div>
      <add-edit-scontent :addEdit="addEditObj" v-model="addEditShow" @changeUpadte="changeUpadte"></add-edit-scontent>
    </el-dialog>
  </div>
</template>

<script>
import addEditScontent from './childComponents/addEditScontent'
import {
  querysuppliertype,
  querysupplierorgnotype, querysupplierservice, deletesupplierservice
} from '../../api/serviceMark'
import {queryorg} from '../../api/organizer'
export default {
  name: 'serviceContent',
  components: {addEditScontent},
  data () {
    return {
      searchKeyword: '',
      supplierorg: [],
      types: [],
      tableData: [],
      orgData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      openTitle: '',
      addEditShow: false,
      addEditObj: {
        isAdd: true,
        row: {},
        allSupplier: [],
        types: [],
        orgData: []
      }
    }
  },
  created () {
    this.getOrgData()
  },
  mounted () {
  },
  computed: {
    // tbdata () {
    //   return this.searchFilterWord()
    // }
  },
  methods: {
    // 组织
    getOrgData () {
      this.loading = true
      queryorg().then(res => {
        this.orgData = res.data.org
        this.addEditObj.orgData = this.orgData
        this.querySupplier()
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务商
    querySupplier () {
      this.loading = true
      let params = {
        page: 1,
        size: 9999
      }
      querysupplierorgnotype(params).then(res => {
        this.querySupplierType()
        this.supplierorg = res.data.org
        this.addEditObj.allSupplier = this.supplierorg
      }).catch(() => {
        this.loading = false
      })
    },
    // 服务类型
    querySupplierType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.querySupplierAndType()
        this.types = res.data.types
        this.addEditObj.types = this.types
      }).catch(() => {
        this.loading = false
      })
    },
    changeUpadte () {
      this.querySupplierType()
    },
    // 表格
    querySupplierAndType () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      this.addEditShow = false
      querysupplierservice(params).then(res => {
        this.loading = false
        this.totalCells = res.data.cnt
        this.tableData = res.data.service
      }).catch(() => {
        this.loading = false
      })
    },
    getSupplierOrg (row) {
      let name = ''
      for (let i = 0; i < this.supplierorg.length; i++) {
        if (row.so_id === this.supplierorg[i].id) {
          name = this.supplierorg[i].name
        }
      }
      return name
    },
    getServiceType (row) {
      for (let i = 0; i < this.types.length; i++) {
        if (row.st_id === this.types[i].id) {
          return this.types[i].typename
        }
      }
    },
    getUpTypeName (upid) {
      let name = ''
      let upids = this.getOrgName1(parseInt(upid), [])
      for (let i = 0; i < upids.length; i++) {
        for (let j = 0; j < this.types.length; j++) {
          if (parseInt(upids[i]) === this.types[j].id) {
            name = this.types[j].typename + ' / ' + name
          }
        }
      }
      return name !== '' ? name.substring(0, name.length - 3) : ''
    },
    getOrgName1 (upid, arr) {
      arr.push(upid)
      for (let i = 0; i < this.types.length; i++) {
        if (parseInt(upid) === this.types[i].id) {
          arr = this.getOrgName1(this.types[i].upid, arr)
        }
      }
      return arr
    },
    // table数据入口（tbdata）
    // searchFilterWord () {
    //   const data = this.tableData
    //   const vm = this
    //   const search = data.filter((val) => {
    //     return true
    //   })
    //   vm.totalCells = search.length
    //   const arr = []
    //   for (let i = (vm.currentPage - 1) * vm.pageSize; i < vm.currentPage * vm.pageSize; i++) {
    //     if (!search[i]) {
    //       break
    //     }
    //     arr.push(search[i])
    //   }
    //   return arr
    // },
    // 新建服务类型
    addServiceContent () {
      this.openTitle = '新增绑定服务内容'
      this.addEditObj.isAdd = true
      this.addEditObj.row = {}
      this.addEditShow = true
    },
    // 编辑服务类型
    editServiceContent (row) {
      this.openTitle = '更新绑定服务内容'
      this.addEditObj.isAdd = false
      this.addEditObj.row = row
      this.addEditShow = true
    },
    // 删除服务类型
    delServiceContent (row) {
      this.$confirm('此操作将永久删除该【' + row.service_name + '】服务内容, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id,
          so_id: row.so_id,
          st_id: row.st_id
        }
        deletesupplierservice(data).then(res => {
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.querySupplierAndType()
        }).catch(() => {})
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.querySupplierAndType()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.querySupplierAndType()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/serviceContent.vue